/**
 * @generated SignedSource<<7eacef446f178901b8f77571d54af132>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EstimatedDeliveryDateDisplay_transaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"shippingTrackingDetails_transaction">;
  readonly " $fragmentType": "EstimatedDeliveryDateDisplay_transaction";
};
export type EstimatedDeliveryDateDisplay_transaction$key = {
  readonly " $data"?: EstimatedDeliveryDateDisplay_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"EstimatedDeliveryDateDisplay_transaction">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "displayValue",
    "storageKey": null
  }
],
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Period",
  "kind": "LinkedField",
  "name": "handlingTime",
  "plural": false,
  "selections": (v0/*:: as any*/),
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Period",
  "kind": "LinkedField",
  "name": "collectionTime",
  "plural": false,
  "selections": (v0/*:: as any*/),
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ShipmentServiceMethod",
  "kind": "LinkedField",
  "name": "serviceMethod",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "describeRange",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = [
  (v3/*:: as any*/),
  (v1/*:: as any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EstimatedDeliveryDateDisplay_transaction",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "shippingTrackingDetails_transaction",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemSkuType",
          "kind": "LinkedField",
          "name": "sku",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "leadTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAvailableNow",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TransactionLeadTime",
          "kind": "LinkedField",
          "name": "leadTime",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasLeadTime",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Shipment",
          "kind": "LinkedField",
          "name": "shipment",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deliveryDateRangeDisplay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "estimatedShippingDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "leadTimeMin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "leadTimeMax",
              "storageKey": null
            },
            (v1/*:: as any*/),
            (v2/*:: as any*/),
            (v3/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TransactionShipmentChangeReview",
          "kind": "LinkedField",
          "name": "pendingShipmentChangeReview",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Shipment",
              "kind": "LinkedField",
              "name": "shipment",
              "plural": false,
              "selections": [
                (v3/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "shipmentType",
                  "storageKey": null
                },
                (v1/*:: as any*/),
                (v2/*:: as any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ShipmentQuote",
              "kind": "LinkedField",
              "name": "shipmentQuote",
              "plural": false,
              "selections": (v4/*:: as any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ShipmentQuote",
          "kind": "LinkedField",
          "name": "currentShipmentQuote",
          "plural": false,
          "selections": (v4/*:: as any*/),
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};
})();

(node as any).hash = "25ba3ea5da99b7606732d7b2fad8fa34";

export default node;
